import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import Loader from './Loader.jsx'
import { useState, Suspense, useEffect } from 'react'
import { useProgress } from '@react-three/drei'
import { createPortal } from 'react-dom'
import { inject } from '@vercel/analytics'

// Initialize Vercel Web Analytics
inject()

function LoadingManager({ onProgress }) {
    const { progress, active } = useProgress()

    // Send progress updates to parent
    onProgress(progress, active)

    return null
}

function App() {
    const [progress, setProgress] = useState(0)
    const [isLoading, setIsLoading] = useState(true)
    const [showLoader, setShowLoader] = useState(true)
    const [firstFrameRendered, setFirstFrameRendered] = useState(false)

    const handleProgress = (prog, active) => {
        setProgress(prog)
        setIsLoading(active)
    }

    // Hide loader only when assets are loaded AND first frame has rendered
    useEffect(() => {
        if (!isLoading && progress >= 100 && firstFrameRendered) {
            setTimeout(() => {
                setShowLoader(false)
            }, 500)
        }
    }, [isLoading, progress, firstFrameRendered])

    const handleFirstFrame = () => {
        setFirstFrameRendered(true)
    }

    return (
        <>
            {showLoader && <Loader progress={progress} isLoading={isLoading} />}
            <Canvas
                className="r3f"
                camera={{
                    fov: 45,
                    near: 0.1,
                    far: 2000,
                    position: [-3, 1.5, 4]
                }}
            >
                <Suspense fallback={null}>
                    <LoadingManager onProgress={handleProgress} />
                    <Experience onFirstFrame={handleFirstFrame} />
                </Suspense>
            </Canvas>
        </>
    )
}

const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(<App />)